import type { ModalOptions } from "@racoon/ui";

// Figma order form, shared by every category tab
export const rowLabelClass = "w-[120px] lg:w-[200px] flex-shrink-0 text-sm font-normal text-text-body";
// Disabled: the field greys out, its icon keeps its colour
export const dropdownTriggerClass =
  "group !m-0 !h-8 w-full min-w-0 !gap-2 !justify-between !px-2 !py-2 rounded-lg border-border-primary text-left !font-normal disabled:!opacity-100 disabled:bg-slate-100";
export const dropdownErrorClass = "!border-red-500 !border-2";
export const chevronClass = "h-4 w-4 flex-shrink-0 text-text-subtle group-disabled:opacity-50";
// The order form's modal, the job card and create alike: the design's frame, the same for
// every category, less on a short screen
export const orderFormModalShell = {
  size: "custom",
  // The design's 1800px frame, held inside a smaller screen
  width: { md: "50rem", xl: "min(1800px, calc(100vw - 2rem))" },
  height: { md: 800 },
  closeButtonTop: "!top-4",
  // 59px + the frame's 1px border: the design's 60px header, above its 1px separator
  headerClassName: "!px-4 !py-0 !pr-12 min-h-[59px]",
} satisfies Partial<ModalOptions>;
export const orderFormBodyClass = "!p-0 flex flex-col flex-1 min-h-0 overflow-hidden";
